import { ModalId } from "../../../../enums/modalId";
import {
  setMetaData,
  setOpenedModalId,
} from "../../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../../redux/store/store";
import {
  createFinalModalMetadata,
  createInitialModalMetadata,
} from "./createModalMetadata";
import { fetchGiData } from "./fetchGiData";
import { fetchProcessedOrdersData } from "./fetchProcessedOrdersData";

/**
 * Opens the order processing info modal, fetches GI screenshot and processed
 * orders data in parallel, then dispatches the final metadata to Redux.
 *
 * @param dispatch - Redux dispatch function.
 * @param giInfoPath - Firestore path variant from singleHealthFacilityDetails
 *   ("api" uses the API-based path, otherwise the default path is used).
 */
export const handleOrdersProcessingInfoClick = async (
  dispatch: AppDispatch,
  giInfoPath?: string,
) => {
  try {
    dispatch(
      setOpenedModalId({
        id: ModalId.ORDER_PROCESSING_INFO_MODAL,
        metaData: createInitialModalMetadata(),
      }),
    );

    const [giData, processedOrdersData] = await Promise.all([
      fetchGiData(giInfoPath),
      fetchProcessedOrdersData(),
    ]);

    dispatch(
      setMetaData(createFinalModalMetadata(giData, processedOrdersData)),
    );
  } catch (error) {
    console.error("Error handling orders processing info click:", error);
    dispatch(
      setMetaData({
        tabs: [],
      }),
    );
  }
};
